import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.aq{box-shadow:0px 0px 15px 0px rgba(0, 0, 0, 0.15);}.ssr-plugin'
import '.ar{border-radius:1.25rem;}.ssr-plugin'
import '.as{background-color:var(--shades-white);}.ssr-plugin'
import '.b0{overflow-y:hidden;}.ssr-plugin'
import '.cy{padding:1rem 1.5rem;}.ssr-plugin'
import '.cz{background:var(--shades-white);}.ssr-plugin'
import '.u{justify-content:space-between;}.ssr-plugin'
import '.g1{padding:2rem 1.5rem;}.ssr-plugin'
import '.g2{max-height:80vh;}.ssr-plugin'
import '.d7{justify-content:flex-end;}.ssr-plugin'
import '.a6{gap:1rem;}.ssr-plugin'
import { styled } from 'inlines'
import { ReactNode } from 'react'
import { Button } from '@app/components/core/button/Button'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { useTranslations } from '@i18n/useLanguage'
import { ModalWrapper } from './ModalWrapper'
import useMediaQuery from '@app/util/useMediaQuery'

export type ModalProps = {
  children: ReactNode
  isOpen: boolean
  title?: string
  loading?: boolean
  renderContainer?: HTMLElement
  onClose: () => void
  onConfirm?: () => void
}

export const Modal = ({
  children,
  isOpen,
  loading,
  title,
  renderContainer,
  onClose,
  onConfirm,
}: ModalProps) => {
  // Always call hooks first
  const translations = useTranslations().app.common
  const isMobile = useMediaQuery()
  // Early return after hooks
  if (!isOpen) {
    return null
  }
  const content = (
    <div className="a b ae aq ar as b0"
      style={{
        maxWidth: isMobile ? '90vw' : 'var(--max-width-modal)',
      }}
    >
      <div className="a cy cz u"
      >
        <Title.H5>{title ?? translations.attention}</Title.H5>
        <CloseButton onClick={onClose} size="small" />
      </div>
      <div className="a b g1 cz g2"
      >
        {children}
      </div>
      <div className="a cy cz d7 a6"
      >
        <Button
          label={translations.back}
          onClick={onClose}
          variant="secondary"
        />
        {onConfirm && (
          <Button
            label={translations.continue}
            onClick={onConfirm}
            disabled={loading}
          />
        )}
      </div>
    </div>
  )

  return (
    <ModalWrapper renderContainer={renderContainer}>{content}</ModalWrapper>
  )
}
